import { IconPen, IconFire } from './icons';
import './MyHeader.css';

export interface MyHeaderProps {
  photoUrl?: string;
  firstName: string;
  projectCount: number;
  streakDays: number;
  level: number;
  onProfileClick: () => void;
}

function projectWord(n: number): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs >= 11 && abs <= 19) return 'проектов';
  if (last === 1) return 'проект';
  if (last >= 2 && last <= 4) return 'проекта';
  return 'проектов';
}

export function MyHeader({
  photoUrl,
  firstName,
  projectCount,
  streakDays,
  level,
  onProfileClick,
}: MyHeaderProps) {
  return (
    <div className="my-header">
      <button
        type="button"
        className="my-header-avatar"
        onClick={onProfileClick}
        aria-label="Профиль"
      >
        {photoUrl ? (
          <img src={photoUrl} alt="" className="my-header-avatar-img" />
        ) : (
          <span className="my-header-avatar-fallback">{firstName[0] || '?'}</span>
        )}
        <span className="my-header-level">{level}</span>
      </button>

      <div className="my-header-info">
        <div className="my-header-title">Мои проекты</div>
        <div className="my-header-subtitle">
          {projectCount} {projectWord(projectCount)} · streak {streakDays}{' '}
          <span className="my-header-streak-icon" aria-hidden><IconFire size={12} /></span>
        </div>
      </div>

      <button
        type="button"
        className="my-header-edit"
        onClick={onProfileClick}
        aria-label="Редактировать профиль"
      >
        <IconPen size={14} />
      </button>
    </div>
  );
}
